export const contactEmail = "info@rusetfs.com";

export const links = {
	social: {
		telegram: 'https://t.me/rusetfs_news'
	},
	footer: {
		forBlogers: 'https://blog.rusetfs.com/posts/%D0%B1%D0%BB%D0%BE%D0%B3%D0%B5%D1%80%D0%B0%D0%BC-%D1%82%D1%80%D0%B5%D0%BD%D0%B5%D1%80%D0%B0%D0%BC-%D0%B8-%D1%84%D0%B8%D0%BD-%D0%BA%D0%BE%D0%BD%D1%81%D1%83%D0%BB%D1%8C%D1%82%D0%B0%D0%BD%D1%82%D0%B0%D0%BC',
		forAds: 'https://blog.rusetfs.com/posts/%D1%80%D0%B5%D0%BA%D0%BB%D0%B0%D0%BC%D0%B0',
		forPartners: 'https://blog.rusetfs.com/posts/%D0%BF%D0%B0%D1%80%D1%82%D0%BD%D0%B5%D1%80%D1%8B',
		termsOfUse: 'https://blog.rusetfs.com/posts/%D0%BF%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D1%81%D0%BA%D0%BE%D0%B5-%D1%81%D0%BE%D0%B3%D0%BB%D0%B0%D1%88%D0%B5%D0%BD%D0%B8%D0%B5-rusetfs',
		foundErrors: 'https://blog.rusetfs.com/posts/%D0%BD%D0%B0%D1%88%D0%BB%D0%B8-%D0%BE%D1%88%D0%B8%D0%B1%D0%BA%D1%83'
	}
}